var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _polygon;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSqreemBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1726.3 249.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#020202;}.cls-2{fill:none;}.cls-3{fill:#6172fa;}.cls-4{fill:#030303;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M433.9,144.9l7.2,9.2c7.6-15.4,8.7-31.5,4.3-47.8-8.1-29.6-32-49.7-62.2-53-44.4-4.8-81.8,32.2-79,74.8,2.2,33.6,24.9,60.2,58,66.7,14,2.7,28.1,2.1,41.3-4.5l-35.5-45.5h66Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M650.5,243.3c-.2-63.9-.2-180.5-.2-180.5,0-.2,0-.3,0-.5h0s0-4.7,0-4.7h4.6,0c.2,0,.4,0,.6,0,20.3.2,40.6.1,60.9,0,3.4,0,6.6.4,9.9,1.1,14.2,3.3,24.7,16.4,24.4,30.7-.3,14.6-10.6,27.1-24.8,30.2-9.1,2-18.2.9-27.4,1-14.9.2-29.8,0-46,0,10.4,13.2,20.1,25.4,29.7,37.6,21.2,26.8,47.4,58.7,68.5,85.5h64.2l-60.1-74.6-2.9-3.4,3.7-2c30.3-14.3,50.6-47.9,46.5-84.4-4.5-40.1-40.3-73.2-80.7-73.2-39.5,0-78.9,0-118.4,0h-4.7v4.8c.1,75.8.1,151.5,0,233l52.1-.6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M436.8,233.2l-33.4-42.8c-13.2,6.6-27.3,7.2-41.3,4.5-33.1-6.5-55.8-33.1-58-66.7-2.8-42.6,34.7-79.6,79-74.8,30.3,3.3,54.2,23.4,62.2,53,4.4,16.3,3.3,32.4-4.3,47.8l34.1,43.7c.3.3.7.6,1,.9,10.4-13.8,17.7-29.1,21.3-46,8.9-41.9-.2-79.5-28.8-111.3C433.2,1.9,379.6-10.2,329.8,8.9c-46.1,17.8-78,61.6-79,113.4-.6,31.1,9.5,58.7,29.6,82.8,37.8,45.1,105.2,57.3,156.4,28.1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M106.4,201.9c-10.4,4.4-21.1,4.5-31.8,2.3-14.8-3.1-28.6-9.3-39.7-23L0,213.9c5.9,6.1,11.1,10.7,16.2,14.5,20.7,15.5,44.8,19.9,69.9,20.6,9.2.3,18.3-1,27.3-2.8,31.6-6.4,57.9-27.8,62.8-61.5,3.8-26.7-3.1-48.7-26.2-64.5-13.7-9.4-29.4-13.7-44.7-19.1-9.7-3.4-19.6-6.1-28.6-11.3-5.3-3.1-9.7-7.1-11.1-13.3-3.2-13.8,3.4-26,17.5-30.2,21.9-6.4,40.9-1.4,61.7,17.2l34.3-35.2c-7.1-6.5-12.4-9.6-17.2-12.2C130.8-1.1,97.9-4.4,64,5.6,31.8,15,8.9,39.4,10.3,76.3c1,25.1,13,42.4,34.7,53.8,10.7,5.7,22.3,9.4,33.8,13.1,11,3.5,22.3,6.6,32,13.3,8.1,5.6,12.7,13.1,11.7,23.2-1.1,10.3-6.2,17.9-16,22.1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M462.9,183c-7.6-9.3-15.4-18.4-22-28.4,0-.1.1-.3.2-.4l-7.2-9.2h-66l35.5,45.5s0,0,0,0c1.8.5,2.6,2,3.6,3.3,5.8,7.3,11.7,14.4,17.3,21.8,4.3,5.8,9.8,10.8,13.1,17.4-.2.1-.4.2-.6.3l9.2,11.7h66l-36.8-47.1c-4.9-4.2-8.2-9.8-12.3-14.8Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M440.9,154.6c6.6,10,14.5,19.1,22,28.4,4,5,7.3,10.6,12.3,14.8l-34.1-43.7c0,.1-.1.3-.2.4Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M424.3,215.5c-5.6-7.4-11.5-14.6-17.3-21.8-1-1.3-1.8-2.8-3.6-3.3,0,0,0,0,0,0l33.4,42.8c.2-.1.4-.2.6-.3-3.4-6.5-8.8-11.6-13.1-17.4Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 900.9,
    y: 195.9,
    width: 191,
    height: 48
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 900.9,
    y: 99.9,
    width: 191,
    height: 48
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 900.9,
    y: 5.9,
    width: 191,
    height: 48
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1200.9,
    y: 195.9,
    width: 191,
    height: 48
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1200.9,
    y: 99.9,
    width: 191,
    height: 48
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1200.9,
    y: 5.9,
    width: 191,
    height: 48
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1701.7 5.9 1612.9 80.4 1524.2 5.9 1500.5 5.9 1500.5 244.4 1550.2 244.4 1550.2 90.6 1612.9 141.6 1675.7 90.6 1675.7 244.4 1725.4 244.4 1725.4 5.9 1701.7 5.9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSqreemBlack);
export default __webpack_public_path__ + "static/media/sqreem-black.a233e57b7ec044265b591c2c21147f2b.svg";
export { ForwardRef as ReactComponent };